export default {
  StorageNamespace: 'amaiz.com-dashboard__',
  emptyChar: '—',
};
